(function () {
    document.addEventListener("DOMContentLoaded", async (event) => {
        // Do not continue if google maps is not loaded
        if (!window.google || !window.google.maps) {
            return;
        }
        
        const allSearchModules = document.querySelectorAll(".search-location-module");
        const { Autocomplete } = await google.maps.importLibrary("places")

        Array.prototype.forEach.call(allSearchModules, (searchModule) => {
            let searchForm = searchModule.querySelector(".search-location-form");
            let options = {
                types: ['geocode'],
                componentRestrictions: { country: "uk" }
            };
            let input = searchForm.querySelector("input.autocomplete");
            let autoComplete = new Autocomplete(input, options);
            let locationForm = {
                searchForm: searchForm,
                latInput: searchForm.querySelector("input[name='Latitude']"),
                longInput: searchForm.querySelector("input[name='Longitude']"),
                autoCompleteInput: searchForm.querySelector("input.autocomplete"),
                autocomplete: autoComplete,
                optionSelected: false,
                requiresAddressLookup: true
            };

            locationForm.searchForm.addEventListener("submit", (e) => onPlaceChanged.setFirstSuggestion(e, locationForm));
            locationForm.autocomplete.addListener("place_changed", () => onPlaceChanged.setClickedLocation(locationForm));
            locationForm.autoCompleteInput.addEventListener("keyup", (e) => onPlaceChanged.checkRequiresAddressLookup(e, locationForm));
            
            const currentLocationCta = searchModule.querySelector(".search-location-module--current-location-cta");
            if (currentLocationCta) {

                if (navigator.geolocation) {
                    currentLocationCta.addEventListener("click", () => {
                        getCurrentLocation.location(locationForm, currentLocationCta);
                    });
                } else {
                    currentLocationCta.remove();
                }
            }
        });
    });

    const onPlaceChanged = {
        setClickedLocation: function (locationForm) {
            let place = locationForm.autocomplete.getPlace();

            if (place.geometry) {
                locationForm.latInput.value = place.geometry.location.lat();
                locationForm.longInput.value = place.geometry.location.lng();

                locationForm.requiresAddressLookup = false;
                locationForm.optionSelected = true;
            }
        },
        setFirstSuggestion: function (e, locationForm) {
            e.preventDefault();
            let pacItem = document.querySelector(".pac-item");

            if (locationForm.requiresAddressLookup && pacItem) {
                let firstResult = pacItem.children;
                let placeName = firstResult[1].textContent;
                let placeAddress = firstResult[2].textContent;

                locationForm.autoCompleteInput.value = placeName + ", " + placeAddress;

                var geocoder = new google.maps.Geocoder();
                geocoder.geocode({"address": placeName, "region": "gb"}, function (results, status) {
                    if (status === google.maps.GeocoderStatus.OK) {
                        let lat = results[0].geometry.location.lat(),
                            lng = results[0].geometry.location.lng();

                        locationForm.latInput.value = lat;
                        locationForm.longInput.value = lng;
                    }

                    locationForm.searchForm.submit();
                });

            } else if (locationForm.optionSelected) {
                locationForm.searchForm.submit();
            }
        },
        checkRequiresAddressLookup: function (e, locationForm) {
            document.querySelector(".location-error-msg").classList.add("is-d-none");

            if (!locationForm.autoCompleteInput.value) {
                // If the user clears the box they are editing their location
                locationForm.requiresAddressLookup = true;
                locationForm.optionSelected = false;
            }

            if (e.keyCode === 46) {
                // If the user presses the backspace key they are editing their location
                locationForm.requiresAddressLookup = true;
                locationForm.optionSelected = false;
            }

            if (e.keyCode === 38 || e.keyCode === 40) {
                // Stop the form submitting if user is using arrow keys up/down to select an option...
                // the first press of the enter key will select the location.
                locationForm.requiresAddressLookup = false;
                locationForm.optionSelected = false;
            }
        }
    };

    const getCurrentLocation = {
        success: function (position, loadingMsg, locationForm) {
            const _this = this;
            const errorMsgEl = document.querySelector(".location-error-msg");
            const geocoder = new google.maps.Geocoder;
            const latlng = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
            };
            let result = {
                error: false,
                value: ""
            };

            geocoder.geocode({"location": latlng}, (results, status) => {
                if (status === 'OK') {
                    if (results[0]) {
                        const resultsData = results[0].address_components;

                        for (let addressComponent of resultsData) {
                            // If you are outside of the UK show an error
                            if (addressComponent.types.indexOf("country") > -1 && addressComponent.short_name !== "GB") {
                                result.error = true;
                                _this.error(result.error, locationForm, loadingMsg);
                                return;
                            }
                            
                            if (addressComponent.types.indexOf("postal_code") > -1) {
                                result.value = addressComponent.long_name;
                                locationForm.autoCompleteInput.value = result.value;
                                locationForm.autoCompleteInput.focus();
                                loadingMsg.classList.add("is-d-none");
                                errorMsgEl.classList.add("is-d-none");
                            }
                        }

                    } else {
                        result.error = true;
                        _this.error(result.error, locationForm, loadingMsg);
                    }
                } else {
                    result.error = true;
                    _this.error(result.error, locationForm, loadingMsg);
                }
            });
        },
        error: function (error = true, locationForm, loadingMsg) {
            if (error.code > 0 || error === true) {
                const errorMsgEl = document.querySelector(".location-error-msg");
                loadingMsg.classList.add("is-d-none");
                errorMsgEl.classList.remove("is-d-none");
                locationForm.autoCompleteInput.focus();
            }
        },
        location: function (locationForm, cta) {
            const loadingMsg = cta.querySelector(".loading-msg");
            const _this = this;

            loadingMsg.classList.remove("is-d-none");
            navigator.geolocation.getCurrentPosition((position) => {
                _this.success(position, loadingMsg, locationForm);

                locationForm.latInput.value = position.coords.latitude;
                locationForm.longInput.value = position.coords.longitude;

                locationForm.optionSelected = true;
                locationForm.requiresAddressLookup = false;

            }, (positionError) => {
                _this.error(positionError, locationForm, loadingMsg);
            });
        }
    };
})();